var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6666 14.0427L24.9999 1.40381L3.33325 14.0427V35.9573L6.68772 37.914L13.5421 35.1407C15.4306 34.3767 16.6667 32.543 16.6667 30.5057V13.3333H20.0001V30.5057C20.0001 33.9013 17.9399 36.957 14.7923 38.2307L10.3275 40.0373L24.9999 48.596L46.6666 35.9573V14.0427ZM23.3333 20C23.3333 16.3181 26.318 13.3333 29.9999 13.3333H33.8889C37.2639 13.3333 39.9999 16.0694 39.9999 19.4444V20H36.6666V19.4444C36.6666 17.9103 35.4229 16.6667 33.8889 16.6667H29.9999C28.159 16.6667 26.6666 18.1591 26.6666 20C26.6666 21.8409 28.159 23.3333 29.9999 23.3333H33.3333C37.0153 23.3333 39.9999 26.3181 39.9999 30C39.9999 33.682 37.0153 36.6667 33.3333 36.6667H29.9999C26.318 36.6667 23.3333 33.682 23.3333 30H26.6666C26.6666 31.8409 28.159 33.3333 29.9999 33.3333H33.3333C35.1743 33.3333 36.6666 31.8409 36.6666 30C36.6666 28.1591 35.1743 26.6667 33.3333 26.6667H29.9999C26.318 26.6667 23.3333 23.6819 23.3333 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.094ed84ac902e1cdfad41f35947b904c.svg";
export { ForwardRef as ReactComponent };